import { COMPANY_LOS_ACTIONS } from "../constants";
import {
    fetchCreateInvoiceJob,
    fetchedCreateInvoiceJob,
    failedFetchCreateInvoiceJob,
    fetchInvoiceJob,
    fetchedInvoiceJob,
    failedFetchInvoiceJob,
    clearInvoiceJob,
    fetchUpdateInvoiceJob,
    fetchedUpdateInvoiceJob,
    failedFetchUpdateInvoiceJob,
    clearUpdateInvoiceJob,
    fetchAllInvoiceJob,
    fetchedAllInvoiceJob,
    failedFetchAllInvoiceJob,
    fetchInvoiceCards,
    fetchedInvoiceCards,
    failedFetchInvoiceCards,
    fetchMarkJobPending,
    fetchedMarkJobPending,
    failedFetchMarkJobPending,
    fetchFinalSubmission,
    fetchedFinalSubmission,
    failedFinalSubmission,
    fetchRemoveInvoice,
    fetchedRemoveInvoice,
    failedRemoveInvoice,
    updateInvoiceJobStatus,
    fetchDealerFromGstin,
    fetchedDealerFromGstin,
    failedFetchDealerFromGstin
} from "./invoice-job-actions";


export {
    fetchCreateInvoiceJob,
    fetchedCreateInvoiceJob,
    failedFetchCreateInvoiceJob,
    fetchInvoiceJob,
    fetchedInvoiceJob,
    failedFetchInvoiceJob,
    clearInvoiceJob,
    fetchUpdateInvoiceJob,
    fetchedUpdateInvoiceJob,
    failedFetchUpdateInvoiceJob,
    clearUpdateInvoiceJob,
    fetchAllInvoiceJob,
    fetchedAllInvoiceJob,
    failedFetchAllInvoiceJob,
    fetchInvoiceCards,
    fetchedInvoiceCards,
    failedFetchInvoiceCards,
    fetchMarkJobPending,
    fetchedMarkJobPending,
    failedFetchMarkJobPending,
    fetchFinalSubmission,
    fetchedFinalSubmission,
    failedFinalSubmission,
    fetchRemoveInvoice,
    fetchedRemoveInvoice,
    failedRemoveInvoice,
    updateInvoiceJobStatus,
    fetchDealerFromGstin,
    fetchedDealerFromGstin,
    failedFetchDealerFromGstin
};

export function fetchDataSyncRequest(companyId, body, type) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_DATA_SYNC_REQUEST,
        payload: {
            companyId,
            body,
            type
        }
    };
}

export function fetchedDataSyncRequest(companyId, body, type, response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_DATA_SYNC_REQUEST,
        payload: {
            companyId,
            body,
            type,
            response
        }
    };
}

export function failedFetchDataSyncRequest(companyId, body, type, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_DATA_SYNC_REQUEST,
        payload: {
            companyId,
            body,
            type,
            error
        }
    };
}

export function setTenor(status, id, tenorId) {
    return {
        type: COMPANY_LOS_ACTIONS.SET_TENOR,
        payload: {
            status,
            id,
            tenorId
        }
    };
}

export function updateTenor() {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_TENOR

    };
}

export function updatingTenor() {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATING_TENOR

    };
}

export function fetchCompanySyncRequestProcessReject(requestId, is_base_file_required, body, formData, automatedFile) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_SYNC_REQUEST_PROCESS_REJECT,
        payload: {
            requestId,
            is_base_file_required,
            body,
            formData, 
            automatedFile
        }
    };
}
export function fetchedCompanySyncRequestProcessReject(requestId, is_base_file_required, body, formData, response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_SYNC_REQUEST_PROCESS_REJECT,
        payload: {
            requestId,
            is_base_file_required,
            body,
            formData,
            response
        }
    };
}
export function failedFetchCompanySyncRequestProcessReject(requestId, is_base_file_required, body, formData, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_SYNC_REQUEST_PROCESS_REJECT,
        payload: {
            requestId,
            is_base_file_required,
            body,
            formData
        },
        error
    };
}


export function fetchCompanySyncRequest(status, pageNo, search, pageSize) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_SYNC_REQUEST,
        payload: {
            status,
            search,
            pageNo,
            pageSize
        }
    };
}
export function fetchedCompanySyncRequest(status, pageNo, search, response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_SYNC_REQUEST,
        payload: {
            status,
            pageNo,
            search,
            response
        }
    };
}
export function failedFetchCompanySyncRequest(status, pageNo, search, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_SYNC_REQUEST,
        payload: {
            status,
            pageNo,
            search
        },
        error
    };
}

export function fetchCompanySyncRequestCount() {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_SYNC_REQUEST_COUNT,
    };
}
export function fetchedCompanySyncRequestCount(response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_SYNC_REQUEST_COUNT,
        payload: {
            response
        }
    };
}
export function failedFetchCompanySyncRequestCount(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_SYNC_REQUEST_COUNT,
        error
    };
}

export function fetchCompanyLosProfileList(filters) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_PROFILE_LIST,
        payload: {
            filters
        }
    };
}
export function fetchedCompanyLosProfileList(filters, companies, totalCount) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_PROFILE_LIST,
        payload: {
            companies,
            filters,
            totalCount
        }
    };
}
export function failedFetchCompanyLosProfileList(filters, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_PROFILE_LIST,
        payload: {
            filters
        },
        error
    };
}

// export function createCompanyLosProfile(companyData, spocData, bank_accounts) {
//     return {
//         type: COMPANY_LOS_ACTIONS.CREATE_COMPANY_LOS_PROFILE,
//         payload: {
//             companyData,
//             spocData,
//             bank_accounts
//         }
//     };
// }

export function createCompanyLosProfile(companyData) {
    return {
        type: COMPANY_LOS_ACTIONS.CREATE_COMPANY_LOS_PROFILE,
        payload: {
            companyData
        }
    };
}

export function createdCompanyLosProfile(data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_PROFILE_LIST,
        payload: {
            data
        }
    };
}
export function failedCreateCompanyLosProfile(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_CREATE_COMPANY_LOS_PROFILE,
        error
    };
}

export function fetchCompanyLosProfile(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_PROFILE,
        payload: {
            companyId
        }

    };
}
export function fetchedCompanyLosProfile(companyId, companyProfile) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_PROFILE,
        payload: {
            companyId,
            companyProfile
        }
    };
}
export function failedFetchCompanyLosProfile(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_PROFILE,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyLosProfile(companyId, companyProfile) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_PROFILE,
        payload: {
            companyId,
            companyProfile
        }
    };
}

export function updatedCompanyLosProfile(companyId, companyProfile) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_PROFILE,
        payload: {
            companyId,
            companyProfile
        }
    };
}
export function failedUpdateCompanyLosProfile(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_PROFILE,
        payload: {
            companyId
        },
        error
    };
}

export function fetchCompanyLosDetail(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_DETAIL,
        payload: {
            companyId
        }
    };
}
export function fetchedCompanyLosDetail(companyId, companyDetails) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_DETAIL,
        payload: {
            companyId,
            companyDetails
        }
    };
}
export function failedFetchCompanyLosDetail(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_DETAIL,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyLosDetail(companyId, companyDetail) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_DETAIL,
        payload: {
            companyId,
            companyDetail
        }

    };
}

export function updatedCompanyLosDetail(companyId, companyDetail) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_DETAIL,
        payload: {
            companyId,
            companyDetail
        }
    };
}
export function failedUpdateCompanyLosDetail(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_DETAIL,
        payload: {
            companyId
        },
        error
    };
}
export function fetchDbRiskControlDetail(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_DB_RISK_CONTROL_DETAIL,
        payload: {
            companyId
        }
    };
}
export function fetchedDbRiskControlDetail(companyId, dbRiskControlDetail) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_DB_RISK_CONTROL_DETAIL,
        payload: {
            companyId,
            dbRiskControlDetail
        }
    };
}
export function failedFetchDbRiskControlDetail(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_DB_RISK_CONTROL_DETAIL,
        payload: {
            companyId
        },
        error
    };
}

export function updateDbRiskControlDetail(companyId, dbRiskControlDetail, requestType=null) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_DB_RISK_CONTROL_DETAIL,
        payload: {
            companyId,
            dbRiskControlDetail,
            requestType
        }

    };
}

export function updatedDbRiskControlDetail(companyId, dbRiskControlDetail) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_DB_RISK_CONTROL_DETAIL,
        payload: {
            companyId,
            dbRiskControlDetail
        }
    };
}
export function failedUpdateDbRiskControlDetail(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_DB_RISK_CONTROL_DETAIL,
        payload: {
            companyId
        },
        error
    };
}



export function fetchCompanyLosAttachments(companyId, is_anchor=false) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_ATTACHMENTS,
        payload: {
            companyId,
            is_anchor
        }
    };
}
export function fetchedCompanyLosAttachments(companyId, companyAttachments) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_ATTACHMENTS,
        payload: {
            companyId,
            companyAttachments
        }
    };
}
export function failedFetchCompanyLosAttachments(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_ATTACHMENTS,
        payload: {
            companyId
        },
        error
    };
}


export function updateCompanyLosAttachments(companyId, companyAttachments) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_ATTACHMENTS,
        payload: {
            companyId,
            companyAttachments
        }
    };
}

export function updatedCompanyLosAttachments(companyId, companyAttachments) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_ATTACHMENTS,
        payload: {
            companyId,
            companyAttachments
        }
    };
}
export function failedUpdateCompanyLosAttachments(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_ATTACHMENTS,
        payload: {
            companyId
        },
        error
    };
}

export function uploadCompanyLosAttachment(companyId, companyAttachment) {
    return {
        type: COMPANY_LOS_ACTIONS.UPLOAD_COMPANY_LOS_ATTACHMENT,
        payload: {
            companyId,
            companyAttachment
        }
    };
}

export function uploadedCompanyLosAttachment(companyId, companyAttachment) {
    return {
        type: COMPANY_LOS_ACTIONS.UPLOADED_COMPANY_LOS_ATTACHMENT,
        payload: {
            companyId,
            companyAttachment
        }
    };
}
export function failedUploadCompanyLosAttachment(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPLOAD_COMPANY_LOS_ATTACHMENT,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyLosSpocUser(companyId, spocUser) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_SPOC_USER,
        payload: {
            companyId,
            spocUser
        }

    };
}

export function updatedCompanyLosSpocUser(companyId, spocUser) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_SPOC_USER,
        payload: {
            companyId,
            spocUser
        }
    };
}
export function failedUpdateCompanyLosSpocUser(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_SPOC_USER,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyDisbursalAccount(companyId, bankDetails) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_DISBURSAL_ACCOUNT,
        payload: {
            companyId,
            bankDetails
        }

    };
}

export function updatedCompanyDisbursalAccount(companyId, bankDetails) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_DISBURSAL_ACCOUNT,
        payload: {
            companyId,
            bankDetails
        }
    };
}
export function failedUpdateCompanyDisbursalAccount(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_DISBURSAL_ACCOUNT,
        payload: {
            companyId
        },
        error
    };
}


export function fetchCompanyLosErps(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_ERPS,
        payload: {
            companyId
        }
    };
}
export function fetchedCompanyLosErps(companyId, companyErps) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_ERPS,
        payload: {
            companyId,
            companyErps
        }
    };
}
export function failedFetchCompanyLosErps(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_ERPS,
        payload: {
            companyId
        },
        error
    };
}
export function fetchCompanyLosBankingFacilities(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_BANKING_FACILITIES,
        payload: {
            companyId
        }
    };
}
export function fetchedCompanyLosBankingFacilities(companyId, bankingFacilities) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_BANKING_FACILITIES,
        payload: {
            companyId,
            bankingFacilities
        }
    };
}
export function failedFetchCompanyLosBankingFacilities(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_BANKING_FACILITIES,
        payload: {
            companyId
        },
        error
    };
}
export function fetchCompanyLosAnnualTurnovers(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_ANNUAL_TURNOVERS,
        payload: {
            companyId
        }
    };
}
export function fetchedCompanyLosAnnualTurnovers(companyId, turnovers) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_ANNUAL_TURNOVERS,
        payload: {
            companyId,
            turnovers
        }
    };
}
export function failedFetchCompanyLosAnnualTurnovers(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_ANNUAL_TURNOVERS,
        payload: {
            companyId
        },
        error
    };
}
export function fetchCompanyLosBrands(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_BRANDS,
        payload: {
            companyId
        }
    };
}
export function fetchedCompanyLosBrands(companyId, brands) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_BRANDS,
        payload: {
            companyId,
            brands
        }
    };
}
export function failedFetchCompanyLosBrands(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_BRANDS,
        payload: {
            companyId
        },
        error
    };
}



export function updateCompanyLosErps(companyId, erps) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_ERPS,
        payload: {
            companyId,
            erps
        }
    };
}

export function updatedCompanyLosErps(companyId, erps) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_ERPS,
        payload: {
            companyId,
            erps
        }
    };
}
export function failedUpdateCompanyLosErps(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_ERPS,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyLosBankingFacilities(companyId, bankingFacilities) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_BANKING_FACILITIES,
        payload: {
            companyId,
            bankingFacilities
        }
    };
}

export function updatedCompanyLosBankingFacilities(companyId, bankingFacilities) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_BANKING_FACILITIES,
        payload: {
            companyId,
            bankingFacilities
        }
    };
}
export function failedUpdateCompanyLosBankingFacilities(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_BANKING_FACILITIES,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyLosAnnualTurnovers(companyId, annualTurnovers) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_ANNUAL_TURNOVERS,
        payload: {
            companyId,
            annualTurnovers
        }
    };
}

export function updatedCompanyLosAnnualTurnovers(companyId, turnovers) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_ANNUAL_TURNOVERS,
        payload: {
            companyId,
            turnovers
        }
    };
}
export function failedUpdateCompanyLosAnnualTurnovers(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_ANNUAL_TURNOVERS,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyLosBrands(companyId, brands) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_BRANDS,
        payload: {
            companyId,
            brands
        }
    };
}

export function updatedCompanyLosBrands(companyId, brands) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_BRANDS,
        payload: {
            companyId,
            brands
        }
    };
}
export function failedUpdateCompanyLosBrands(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_BRANDS,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyLosSchemes(companyId, schemes) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_LOS_SCHEMES,
        payload: {
            companyId,
            schemes
        }
    };
}

export function updatedCompanyLosSchemes(companyId, schemes) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_LOS_SCHEMES,
        payload: {
            companyId,
            schemes
        }
    };
}
export function failedUpdateCompanyLosSchemes(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_LOS_SCHEMES,
        payload: {
            companyId
        },
        error
    };
}

export function fetchCompanyLosSchemes(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_LOS_SCHEMES,
        payload: {
            companyId
        }
    };
}
export function fetchedCompanyLosSchemes(companyId, schemes) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_LOS_SCHEMES,
        payload: {
            companyId,
            schemes
        }
    };
}
export function failedFetchCompanyLosSchemes(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_LOS_SCHEMES,
        payload: {
            companyId
        },
        error
    };
}



export function fetchFee(companyId, fee_product_type = null) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_FEE,
        payload: {
            companyId,
            fee_product_type
        }
    };
}
export function fetchedFee(companyId, response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_FEE,
        payload: {
            companyId,
            response
        }
    };
}
export function failedFetchFee(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_FEE,
        error,
        payload: {
            companyId
        }
    };
}

export function fetchFeeMaster() {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_FEE_MASTER,
    };
}
export function fetchedFeeMaster(response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_FEE_MASTER,
        payload: {
            response
        }
    };
}
export function failedFetchFeeMaster(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_FEE_MASTER,
        error
    };
}

export function fetchAddFee(companyId, fee) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_ADD_FEE,
        payload: {
            companyId,
            fee
        }
    };
}
export function fetchedAddFee(companyId, fee, response) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_ADD_FEE,
        payload: {
            companyId,
            fee,
            response
        }
    };
}
export function failedFetchAddFee(companyId, fee, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_ADD_FEE,
        error,
        payload: {
            companyId,
            fee
        }
    };
}

export function deleteBrands(brandId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.DELETE_BRANDS,
        payload: {
            brandId, companyId
        }
    };
}

export function deletedBrands(brandId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.DELETED_BRANDS,
        payload: {
            brandId, companyId
        }
    };
}

export function failedeleteBrands(brandId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_DELETE_BRANDS,
        payload: {
            brandId, companyId
        }
    };
}

export function deleteTurnovers(turnoverId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.DELETE_ANNUAL_TURNOVER,
        payload: {
            turnoverId, companyId
        }
    };
}

export function deletedTurnovers(turnoverId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.DELETED_ANNUAL_TURNOVER,
        payload: {
            turnoverId, companyId
        }
    };
}

export function failedeleteTurnovers(turnoverId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_DELETE_ANNUAL_TURNOVER,
        payload: {
            turnoverId, companyId
        }
    };
}

export function deleteErpDetails(erpId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.DELETE_ERP_DETAILS,
        payload: {
            erpId, companyId
        }
    };
}

export function deletedErpDetails(erpId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.DELETED_ERP_DETAILS,
        payload: {
            erpId, companyId
        }
    };
}

export function failedeleteErpDetails(erpId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_DELETE_ERP_DETAILS,
        payload: {
            erpId, companyId
        }
    };
}

export function deleteBankingFacility(facilityId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.DELETE_BANKING_FACILITY,
        payload: {
            facilityId, companyId
        }
    };
}

export function deletedBankingFacility(facilityId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.DELETED_BANKING_FACILITY,
        payload: {
            facilityId, companyId
        }
    };
}

export function failedeleteBankingFacility(facilityId, companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_DELETE_BANKING_FACILITY,
        payload: {
            facilityId, companyId
        }
    };
}

export function fetchTenorList() {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_TENOR_LIST
    };
}

export function fetchedTenorList(data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_TENOR_LIST,
        payload: {
            data
        }
    };
}

export function failedFetchTenorList(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_TENOR_LIST,
        error
    };
}

export function fetchMarginList(tenorId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_MARGIN_LIST,
        payload: {
            tenorId
        }
    };
}

export function fetchedMarginList(tenorId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_MARGIN_LIST,
        payload: {
            data,
            tenorId
        }
    };
}

export function failedFetchMarginList(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_MARGIN_LIST,
        error
    };
}

export function fetchCashbackList() {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_CASHBACK_LIST
    };
}

export function fetchedCashbackList(data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_CASHBACK_LIST,
        payload: {
            data
        }
    };
}

export function failedFetchCashbackList(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_CASHBACK_LIST,
        error
    };
}

export function fetchInterestList(tenorId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_INTEREST_LIST,
        payload: {
            tenorId
        }
    };
}

export function fetchedInterestList(tenorId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_INTEREST_LIST,
        payload: {
            data,
            tenorId
        }
    };
}

export function failedFetchInterestList(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_INTEREST_LIST,
        error
    };
}

export function fetchWithholdPercMaster() {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_WITHHOLD_PERC_MASTER
    };
}

export function fetchedWithholdPercMaster(data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_WITHHOLD_PERC_MASTER,
        payload: {
            data
        }
    };
}

export function failedFetchWithholdPercMaster(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_WITHHOLD_PERC_MASTER,
        error
    };
}

export function fetchCompanySellerSchemes(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_SELLER_SCHEME,
        payload: {
            companyId
        }
    };
}

export function fetchedCompanySellerSchemes(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_SELLER_SCHEME,
        payload: {
            companyId,
            data
        }
    };
}

export function failedFetchCompanySellerSchemes(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_SELLER_SCHEME,
        payload: {
            companyId
        },
        error
    };
}

export function createSellerScheme(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.CREATE_COMPANY_SELLER_SCHEME,
        payload: {
            companyId,
            data
        }
    };
}

export function createdSellerScheme(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.CREATED_COMPANY_SELLER_SCHEME,
        payload: {
            companyId,
            data
        }
    };
}

export function failedCreateSellerScheme(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_CREATE_COMPANY_SELLER_SCHEME,
        error
    };
}

export function createSellerSchemeMapping(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.CREATE_COMPANY_SELLER_SCHEME_MAPPING,
        payload: {
            companyId,
            data
        }
    };
}

export function createdSellerSchemeMapping(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.CREATED_COMPANY_SELLER_SCHEME_MAPPING,
        payload: {
            companyId,
            data
        }
    };
}

export function failedCreateSellerSchemeMapping(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_CREATE_COMPANY_SELLER_SCHEME_MAPPING,
        error
    };
}

export function fetchCompanySellerSchemesMappings(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_SELLER_SCHEME_MAPPING,
        payload: {
            companyId
        }
    };
}

export function fetchedCompanySellerSchemesMappings(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_SELLER_SCHEME_MAPPING,
        payload: {
            companyId,
            data
        }
    };
}

export function failedFetchCompanySellerSchemesMappings(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_SELLER_SCHEME_MAPPING,
        payload: {
            companyId
        },
        error
    };
}

export function updateSellerSchemeMapping(companyId, schemeId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_SELLER_SCHEME_MAPPING,
        payload: {
            companyId,
            data,
            schemeId
        }
    };
}

export function updatedSellerSchemeMapping(companyId, schemeId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_SELLER_SCHEME_MAPPING,
        payload: {
            companyId,
            data,
            schemeId
        }
    };
}

export function failedUpdateSellerSchemeMapping(companyId, schemeId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_SELLER_SCHEME_MAPPING,
        error,
        payload: {
            schemeId,
            companyId
        }
    };
}

export function updateSellerScheme(companyId, schemeId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_SELLER_SCHEME,
        payload: {
            companyId,
            schemeId,
            data
        }
    };
}

export function updatedSellerScheme(companyId, schemeId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_SELLER_SCHEME,
        payload: {
            companyId,
            schemeId,
            data
        }
    };
}

export function failedUpdateSellerScheme(companyId, schemeId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_SELLER_SCHEME,
        payload: {
            companyId,
            schemeId
        },
        error
    };
}

export function createCompanyAgreement(companyId, agreement) {
    return {
        type: COMPANY_LOS_ACTIONS.CREATE_AGREEMENT,
        payload: {
            companyId,
            agreement
        }
    };
}

export function createdCompanyAgreement(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.CREATED_AGREEMENT,
        payload: {
            companyId,
            data
        }
    };
}

export function failedCreateCompanyAgreement(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_CREATE_AGREEMENT,
        error,
        payload: {
            companyId
        }
    };
}

export function fetchCompanyAgreement(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_AGREEMENT,
        payload: {
            companyId
        }
    };
}

export function fetchedCompanyAgreement(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_AGREEMENT,
        payload: {
            companyId,
            data
        }
    };
}

export function failedFetchCompanyAgreement(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_AGREEMENT,
        error,
        payload: {
            companyId
        }
    };
}

export function updateCompanyAgreement(companyId, agreement) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_AGREEMENT,
        payload: {
            companyId,
            agreement
        }
    };
}

export function updatedCompanyAgreement(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_AGREEMENT,
        payload: {
            companyId,
            data
        }
    };
}

export function failedUpdateCompanyAgreement(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_AGREEMENT,
        error,
        payload: {
            companyId
        }
    };
}

export function fetchCompanyAgreementDetail(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_AGREEMENT_DETAIL,
        payload: {
            companyId
        }
    };
}

export function fetchedCompanyAgreementDetail(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_AGREEMENT_DETAIL,
        payload: {
            companyId,
            data
        }
    };
}

export function failedFetchCompanyAgreementDetail(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_AGREEMENT_DETAIL,
        payload: {
            companyId
        },
        error
    };
}

export function generatePdf(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.GENERATE_PDF,
        payload: {
            companyId,
            data
        }
    };
}

export function generatedPdf(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.GENERATED_PDF,
        payload: {
            companyId,
            data
        }
    };
}

export function failedGeneratePdf(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_GENERATE_PDF,
        payload: {
            companyId
        },
        error
    };
}

export function updateCompanyAddress(companyId, type, address) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_COMPANY_PROFILE_ADDRESS,
        payload: {
            companyId,
            address,
            type
        }
    };
}

export function updatedCompanyAddress(companyId, type, address) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_COMPANY_PROFILE_ADDRESS,
        payload: {
            companyId,
            type,
            address
        }
    };
}

export function failedUpdateCompanyAddress(companyId, type, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_COMPANY_PROFILE_ADDRESS,
        payload: {
            companyId,
            type
        },
        error
    };
}

export function validateDocument(company_id, file) {
    return {
        type: COMPANY_LOS_ACTIONS.VALIDATE_COMPANY_DOCUMENT,
        payload: {
            company_id,
            file
        }
    };
}

export function validatedDocument(company_id, file) {
    return {
        type: COMPANY_LOS_ACTIONS.VALIDATED_COMPANY_DOCUMENT,
        payload: {
            company_id,
            file
        }
    };
}

export function failedValidateDocument(company_id, file, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_VALIDATE_COMPANY_DOCUMENT,
        payload: {
            company_id,
            file
        },
        error
    };
}

export function invalidateDocument(company_id, file) {
    return {
        type: COMPANY_LOS_ACTIONS.INVALIDATE_COMPANY_DOCUMENT,
        payload: {
            company_id,
            file
        }
    };
}

export function invalidatedDocument(company_id, file) {
    return {
        type: COMPANY_LOS_ACTIONS.INVALIDATED_COMPANY_DOCUMENT,
        payload: {
            company_id,
            file
        }
    };
}

export function failedInvalidateDocument(company_id, file, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_INVALIDATE_COMPANY_DOCUMENT,
        payload: {
            company_id,
            file
        },
        error
    };
}

export function fetchRetailerMapping(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_RETAILER_MAPPING,
        payload: {
            companyId
        }
    };
}

export function fetchCompanyVisibilitySheetData(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_COMPANY_VISIBILITY_SHEET_DATA,
        payload: {
            companyId
        }
    };
}

export function fetchedCompanyVisibilitySheetData(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_COMPANY_VISIBILITY_SHEET_DATA,
        payload: {
            companyId,
            data
        }
    };
}

export function failedFetchCompanyVisibilitySheetData(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_COMPANY_VISIBILITY_SHEET_DATA,
        payload: {
            companyId,
            error
        }
    };
}


export function fetchSellerLedgerMaster(companyId, filters = {}) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_SELLER_LEDGER_MASTER,
        payload: {
            companyId,
            filters
        }
    };
}

export function fetchedRetailerMapping(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_RETAILER_MAPPING,
        payload: {
            companyId,
            data
        }
    };
}
export function fetchedSellerLedgerMaster(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_SELLER_LEDGER_MASTER,
        payload: {
            companyId,
            data
        }
    };
}

export function failedFetchRetailerMapping(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_RETAILER_MAPPING,
        payload: {
            companyId,
            error
        }
    };
}
export function failedFetchSellerLedgerMaster(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_SELLER_LEDGER_MASTER,
        payload: {
            companyId,
            error
        }
    };
}

export function addRetailerMapping(companyId, retailerMapping) {
    return {
        type: COMPANY_LOS_ACTIONS.ADD_RETAILER_MAPPING,
        payload: {
            companyId,
            retailerMapping
        }
    };
}

export function updateSellerLedgerMaster(companyId, ledgerEntries) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_SELLER_LEDGER_MASTER,
        payload: {
            companyId,
            ledgerEntries
        }
    };
}

export function addedRetailerMapping(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.ADDED_RETAILER_MAPPING,
        payload: {
            companyId,
            data
        }
    };
}

export function updatedSellerLedgerMaster(companyId, data) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_SELLER_LEDGER_MASTER,
        payload: {
            companyId,
            data
        }
    };
}

export function failedAddRetailerMapping(companyId, retailerMapping, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_ADD_RETAILER_MAPPING,
        payload: {
            companyId,
            retailerMapping,
            error
        }
    };
}

export function failedUpdateSellerLedgerMaster(companyId, error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_SELLER_LEDGER_MASTER,
        payload: {
            companyId,
            error
        }
    };
}

export function fetchCaseSellerList() {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_CASES_AS_SELLER
    };
}

export function fetchedCaseSellerList() {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_CASES_AS_SELLER

    };
}
//Update Document status and Singzy Data
export function updateDocumentStatus(companyId , file) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATE_DOCUMENT_STATUS,
        payload: {
            companyId,
            file
        }
    };
}

export function updatedDocumentStatus(data) {
    return {
        type: COMPANY_LOS_ACTIONS.UPDATED_DOCUMENT_STATUS,
        payload: {
            data
        }
    };
}

export function failedUpdateDocumentStatus(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_UPDATE_DOCUMENT_STATUS,
        payload: {
            error
        }
    };

}
//Get Cam Engine Automation View
export function fetchCamEngineView(caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_CAM_ENGINE,
        payload: {
            caseId
        }
    };
}

export function fetchedCamEngineView(data, caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_CAM_ENGINE,
        payload: {
            data,
            caseId
        }
    };
}

export function failedFetchCamEngineView(error, caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_CAM_ENGINE,
        payload: {
            error,
            caseId
        }
    };
}
//Get Cam Engine Comments Data
export function fetchCamEngineViewComments(caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_CAM_ENGINE_COMMENTS,
        payload: {
            caseId
        }
    };
}

export function fetchedCamEngineViewComments(data, caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_CAM_ENGINE_COMMENTS,
        payload: {
            data,
            caseId
        }
    };
}

export function failedFetchCamEngineViewComments(error, caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_CAM_ENGINE_COMMENTS,
        payload: {
            error,
            caseId
        }
    };
}

//Get Cam Engine Status Logs
export function fetchCamEngineStatusLogs(caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_CAM_ENGINE_STATUS_LOGS,
        payload: {
            caseId
        }
    };
}

export function fetchedCamEngineStatusLogs(data, caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_CAM_ENGINE_STATUS_LOGS,
        payload: {
            data,
            caseId
        }
    };
}

export function failedFetchCamEngineStatusLogs(error, caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_CAM_ENGINE_STATUS_LOGS,
        payload: {
            error,
            caseId
        }
    };
}

//Get Portfolio View
export function fetchPortfolioView(caseId, stageId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_PORTFOLIO_VIEW,
        payload: {
            caseId,
            stageId,
        }
    };
}

export function fetchedPortfolioView(data, caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_PORTFOLIO_VIEW,
        payload: {
            data,
            caseId
        }
    };
}

export function failedFetchPortfolioView(error, caseId) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_PORTFOLIO_VIEW,
        payload: {
            error,
            caseId
        }
    };
}

//Bounce charges fetch actions
export function fetchBounceCharges(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_BOUNCE_CHARGES,
        payload: {
            companyId: companyId
        }
    };
}

export function fetchedBounceCharges(data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_BOUNCE_CHARGES,
        payload: {
            data
        }
    };
}

export function failedFetchBounceCharges(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_BOUNCE_CHARGES,
        error
    };
}

//Pre Payment charges fetch actions
export function fetchPrePaymentCharges(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_PRE_PAYMENT_CHARGES,
        payload: {
            companyId: companyId
        }
    };
}

export function fetchedPrePaymentCharges(data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_PRE_PAYMENT_CHARGES,
        payload: {
            data
        }
    };
}

export function failedFetchPrePaymentCharges(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_PRE_PAYMENT_CHARGES,
        error
    };
}


//Bounce charges fetch actions Master
export function fetchBounceChargesMaster(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_BOUNCE_CHARGES_MASTER,
        payload: {
            companyId: companyId
        }
    };
}

export function fetchedBounceChargesMaster(data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_BOUNCE_CHARGES_MASTER,
        payload: {
            data
        }
    };
}

export function failedFetchBounceChargesMaster(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_BOUNCE_CHARGES_MASTER,
        error
    };
}

//Pre Payment charges fetch actions Master
export function fetchPrePaymentChargesMaster(companyId) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCH_PRE_PAYMENT_CHARGES_MASTER,
        payload: {
            companyId: companyId
        }
    };
}

export function fetchedPrePaymentChargesMaster(data) {
    return {
        type: COMPANY_LOS_ACTIONS.FETCHED_PRE_PAYMENT_CHARGES_MASTER,
        payload: {
            data
        }
    };
}

export function failedFetchPrePaymentChargesMaster(error) {
    return {
        type: COMPANY_LOS_ACTIONS.FAILED_FETCH_PRE_PAYMENT_CHARGES_MASTER,
        error
    };
}